import { Button, BUTTON_THEME, Icon } from '@st-operations/uikit/src/v2'
import React, { useMemo, useEffect } from 'react'

import MultiValueInput from '_components/multi-value-input/index.jsx'
import useTotalUsers from '../hooks/useTotalUsers'
import MonthlyUserCount from '../monthly-user-count'

import './styles.scss'

const EventFeedsWizardTerms = ({
  onBackClick,
  terms,
  onTermsChange,
  onSkip,
  onAddTerms,
  cumulativeFilters,
  onCumulativeFiltersChange,
}) => {
  const payload = useMemo(() => {
    const withoutKecc = cumulativeFilters.filter((f) => f.key !== 'kecc')
    return terms?.length > 0
      ? { filters: [...withoutKecc, { key: 'kecc', operator: 'in', value: terms }] }
      : { filters: [...withoutKecc] }
  }, [terms])

  const [totalUsers] = useTotalUsers(payload)

  useEffect(() => {
    if (onCumulativeFiltersChange) {
      onCumulativeFiltersChange(payload.filters)
    }
  }, [payload])

  return (
    <div className="event-feeds-wizard-terms__container">
      <Button
        theme={BUTTON_THEME.GHOST}
        onClick={onBackClick}
        className="event-feeds-wizard-terms__back-button"
      >
        <Icon type="outline" icon="angleleft" />
        Back
      </Button>
      <span className="event-feeds-wizard-terms__title">{`2. I'm interested in these terms:`}</span>
      <MultiValueInput
        name="value"
        className="event-feeds-wizard-terms__input"
        values={terms}
        onChange={(t) => onTermsChange(t)}
      />
      <MonthlyUserCount totalUsers={totalUsers} />
      <Button theme={BUTTON_THEME.GHOST} onClick={onSkip}>
        Skip
      </Button>
      <div className="event-feeds-wizard-terms__add-terms-container">
        <Button
          className="event-feeds-wizard-terms__add-terms-button"
          disabled={terms.length === 0}
          onClick={onAddTerms}
        >
          Add Terms
        </Button>
      </div>
    </div>
  )
}

export default EventFeedsWizardTerms
